
























import { Component, Vue } from "vue-property-decorator";

@Component
export default class About extends Vue {
  version = process.env.VUE_APP_VERSION || "dev";
}
